const e = {
  normal: 400,
  medium: 500,
  bold: 700,
  extraBold: 800
}, t = {
  normal10: {
    fontSize: "10px",
    lineHeight: "12px",
    fontWeight: e.normal,
    letterSpacing: 0
  },
  medium10: {
    fontSize: "10px",
    lineHeight: "12px",
    fontWeight: e.medium,
    letterSpacing: 0
  },
  normal12: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: e.normal,
    letterSpacing: 0
  },
  medium12: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: e.medium,
    letterSpacing: 0
  },
  underlined12: {
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: e.normal,
    letterSpacing: 0,
    textDecoration: "underline"
  }
}, i = {
  normal14: {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  medium14: {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: e.medium,
    letterSpacing: "-0.01rem"
  },
  bold14: {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  underlined14: {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem",
    textDecoration: "underline"
  },
  normal16: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  medium16: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: e.medium,
    letterSpacing: "-0.01rem"
  },
  bold16: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  underlined16: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem",
    textDecoration: "underline"
  },
  normal18: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  medium18: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: e.medium,
    letterSpacing: "-0.01rem"
  },
  bold18: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  underlined18: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem",
    textDecoration: "underline"
  },
  normal20: {
    fontSize: "20px",
    lineHeight: "28px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  medium20: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: e.medium,
    letterSpacing: "-0.01rem"
  },
  bold20: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  underlined20: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem",
    textDecoration: "underline"
  }
}, n = {
  normal14: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  medium14: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: e.medium,
    letterSpacing: "-0.01rem"
  },
  bold14: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  underlined14: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem",
    textDecoration: "underline"
  },
  normal16: {
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  medium16: {
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: e.medium,
    letterSpacing: "-0.01rem"
  },
  bold16: {
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  underlined16: {
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem",
    textDecoration: "underline"
  },
  normal18: {
    fontSize: "18px",
    lineHeight: "22px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  bold18: {
    fontSize: "18px",
    lineHeight: "22px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  extraBold18: {
    fontSize: "18px",
    lineHeight: "22px",
    fontWeight: e.extraBold,
    letterSpacing: "-0.01rem"
  },
  normal20: {
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  bold20: {
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  extraBold20: {
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: e.extraBold,
    letterSpacing: "-0.01rem"
  },
  normal24: {
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  bold24: {
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  extraBold24: {
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: e.extraBold,
    letterSpacing: "-0.01rem"
  },
  normal26: {
    fontSize: "26px",
    lineHeight: "32px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  bold26: {
    fontSize: "26px",
    lineHeight: "32px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  extraBold26: {
    fontSize: "26px",
    lineHeight: "32px",
    fontWeight: e.extraBold,
    letterSpacing: "-0.01rem"
  },
  normal32: {
    fontSize: "32px",
    lineHeight: "40px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  bold32: {
    fontSize: "32px",
    lineHeight: "40px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  extraBold32: {
    fontSize: "32px",
    lineHeight: "40px",
    fontWeight: e.extraBold,
    letterSpacing: "-0.01rem"
  },
  normal40: {
    fontSize: "40px",
    lineHeight: "48px",
    fontWeight: e.normal,
    letterSpacing: "-0.01rem"
  },
  bold40: {
    fontSize: "40px",
    lineHeight: "48px",
    fontWeight: e.bold,
    letterSpacing: "-0.01rem"
  },
  extraBold40: {
    fontSize: "40px",
    lineHeight: "48px",
    fontWeight: e.extraBold,
    letterSpacing: "-0.01rem"
  }
}, o = {
  bold52: {
    fontSize: "52px",
    lineHeight: "56px",
    fontWeight: e.bold
  },
  extraBold52: {
    fontSize: "52px",
    lineHeight: "56px",
    fontWeight: e.extraBold
  },
  bold56: {
    fontSize: "56px",
    lineHeight: "60px",
    fontWeight: e.bold
  },
  extraBold56: {
    fontSize: "56px",
    lineHeight: "60px",
    fontWeight: e.extraBold
  }
};
export {
  i as body,
  o as display,
  n as heading,
  t as label,
  e as weight
};
